import { IComponentOptions } from 'angular';
import { GradPlanningTransferTableCtrl } from './grad-planning-transfer-table.controller';

export const GradPlanningTransferTableComponent: IComponentOptions = {
  bindings: {
    //
  },
  controller: GradPlanningTransferTableCtrl,
  template: require('./grad-planning-transfer-table.html'),
};
